import React from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from "react-router-dom";
import Dashboard from "./application/Dashboard";
import DashboardHome from "./application/dashboard/DashboardHome";
import UsersPage from "./application/users/UsersPage";
import BlockedDomains from "./application/blockedDomains/BlockedDomains";
import SearchStatsPage from "./application/searchStats/SearchStatsPage";
import CompaniesPage from "./application/companies/CompaniesPage";
import SettingsPage from "./application/settings/SettingsPage";
import LinkListsPage from "./application/linkLists/LinkListPage";
import CmsSearch from "./application/cmsSearch/CmsSearch";

// 🔐 Rollen-Helpers
import { getCurrentUser, hasAnyRole } from "./utils/auth";

// kleiner 403 Screen
function Forbidden() {
    return <div style={{ padding: 24 }}>403 – Keine Berechtigung</div>;
}

// Wrapper für geschützte Routen
function ProtectedRoute({ allow = [], children }) {
    const user = getCurrentUser();
    if (!user) return <Navigate to="/dashboard" replace />;      // oder auf /login
    if (!hasAnyRole(user, allow)) return <Forbidden />;
    return <>{children}</>;
}

export default function MainApp() {
    return (
        <Router>
            <Routes>
                <Route path="/dashboard" element={<Dashboard />}>
                    <Route index element={<DashboardHome />} />
                    <Route path="statistics" element={<SearchStatsPage />} />
                    <Route
                        path="users"
                        element={
                            <ProtectedRoute allow={["admin"]}>
                                <UsersPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="blocked-domains"
                        element={
                            <ProtectedRoute allow={["admin"]}>
                                <BlockedDomains />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="linklists"
                        element={
                            <ProtectedRoute allow={["admin"]}>
                                <LinkListsPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="cms-search"
                        element={
                            <ProtectedRoute allow={["admin"]}>
                                <CmsSearch />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="companies"
                        element={
                            <ProtectedRoute allow={["admin"]}>
                                <CompaniesPage />
                            </ProtectedRoute>
                        }
                    />
                    <Route
                        path="settings"
                        element={
                            <ProtectedRoute allow={["admin"]}>
                                <SettingsPage />
                            </ProtectedRoute>
                        }
                    />
                </Route>
                <Route path="*" element={<Navigate to="/dashboard" replace />} />
            </Routes>
        </Router>
    );
}
